const SVG = ({ fill = 'none', width = '24', height = '24', viewBox = '0 0 24 24' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      transform="rotate(2 12 12)"
      stroke="#4E546C"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeDasharray="0.01 3"
      r="10.635"
    />
    <path
      d="M21.273 6.792a10.635 10.635 0 10-9.399 15.843"
      stroke="#192043"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path d="M11.914 5v7.087L17 15.5" stroke="#4E546C" strokeWidth="1.25" strokeLinecap="round" />
  </svg>
)

export default SVG
